import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProductPage } from '../components/ProductPage';
import { Footer } from '../components/Footer';
export const Product = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2353">
      <Navbar data-id="element-2354" />
      <ProductPage data-id="element-2355" />
      <Footer data-id="element-2356" />
    </div>;
};